/**
 * ButtonBlock - Button element for DesignerCanvas
 *
 * A styled button with configurable variant.
 */

import { memo } from 'react';
import type { ButtonBlockElement } from '@deep-agents/shared-types';

interface ButtonBlockProps {
  element: ButtonBlockElement;
  onUpdate?: (props: Partial<ButtonBlockElement['props']>) => void;
}

// Variant styling
const variantClasses = {
  primary: 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm',
  secondary: 'bg-slate-600 text-white hover:bg-slate-700 shadow-sm',
  outline: 'bg-transparent text-slate-700 border-2 border-slate-300 hover:border-slate-400',
  ghost: 'bg-transparent text-slate-600 hover:bg-slate-100',
};

export const ButtonBlock = memo(({ element }: ButtonBlockProps) => {
  const { label = 'Button', variant = 'primary' } = element.props;

  const baseClasses = 'w-full h-full flex items-center justify-center px-4 py-2 rounded-lg font-medium text-sm transition-colors cursor-pointer';
  const variantClass = variantClasses[variant];

  return (
    <div className={`${baseClasses} ${variantClass}`}>
      {label}
    </div>
  );
});

ButtonBlock.displayName = 'ButtonBlock';
